/**
 * Returns true when the given Member Association is in "Applying" status.
 *
 * Applying MAs have their membership (and IPMA fees) frozen, so a number of
 * my.ipma rights are suspended (e-library, accepting members, creating events,
 * board/officer positions). Full MAs and AfMAs (transitional) are unaffected.
 *
 * Accepts either a memberAssociation object ({ applying }) or null/undefined.
 */
const isApplyingMa = (memberAssociation) => !!(memberAssociation && memberAssociation.applying);

export default isApplyingMa;
